import React, { ChangeEvent, FC, InputHTMLAttributes } from "react";
import clsx from "clsx";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  ipSize?: "lg" | "md";
  label?: string;
  subLabel?: string;
  isError?: boolean;
  errorMessage?: string;
  wrapClassName?: string;
  className?: string;
  iconType?: "stroke" | "fill";
  iconRight?: React.ElementType;
}

export const Radio: FC<Props> = ({
  ipSize = "lg",
  label,
  subLabel,
  isError,
  errorMessage,
  className,
  wrapClassName,
  disabled,
  id,
  ...rest
}) => {
  return (
    <div className={clsx("mb-5", disabled && "opacity-50", wrapClassName)}>
      <div className="relative flex items-center">
        <div
          className={clsx(
            "flex items-center h-5",
            !disabled && "cursor-pointer"
          )}
        >
          <input
            {...rest}
            id={id}
            type="radio"
            className={clsx(
              "focus:ring-transparent text-blue",
              ipSize === "md" ? "h-4 w-4" : "h-5 w-5",
              disabled ? "text-neutral-20" : "cursor-pointer",
              isError ? "border-red" : "border-neutral-30",
              className
            )}
            disabled={disabled}
          />
        </div>
        {Boolean(label) && (
          <div
            className={clsx(
              "ml-3 text-base",
              disabled ? "cursor-not-allowed" : "cursor-pointer"
            )}
            onClick={() => {
              if (disabled) return;
              rest.onChange?.(
                rest.value as unknown as ChangeEvent<HTMLInputElement>
              );
            }}
          >
            <label
              htmlFor={id}
              className={clsx(
                "text-neutral-70",
                disabled ? "cursor-not-allowed" : "cursor-pointer"
              )}
            >
              {label}
              {Boolean(subLabel) && (
                <div className="text-sm font-normal text-neutral-50">
                  {subLabel}
                </div>
              )}
            </label>
          </div>
        )}
      </div>
      {Boolean(errorMessage) && (
        <p className="mt-[0.375rem] text-sm text-red" id="email-error">
          {errorMessage}
        </p>
      )}
    </div>
  );
};
